import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import Refuse from './Refuse.js';
import History from './History.js';
import HistoryList from './HistoryList.js';
import { apis } from '../api/index.js';
import qs from 'query-string';
import AlertTips from './AlertTips.js';
import { Icon, Breadcrumb, Input, Button, Checkbox } from 'antd';
import { message, Modal, Tabs, Spin, Popover, Radio } from 'antd';
import { changeListWidth, reportInfo, eventListener } from '../utils';
import { formatDate, aiReportLocalStorage, ClearIcon } from '../utils';
import { breadItem, isIncluded } from '../utils';
import { setCountTime } from '../utils';
import OneNameHistory from './OneNameHistory';
import Knowledge from './Knowledge';
import ApplyInfo from './ApplyInfo';
import Score from './Score';
import ReportButtons from './ReportButtons.js';
import '../style/report.css';

const { TextArea } = Input;
const { TabPane } = Tabs;
const { confirm } = Modal;

class Report extends React.Component {
  static propTypes = {
    server: PropTypes.object,
    history: PropTypes.object,
    setApplicationData: PropTypes.func,
    match: PropTypes.object,
    changeMenuTaskData: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      listWidth: 'calc(87% - 8px)',
      diagId: props.match.params.diagId,
      state: props.match.params.state,
      applicationId: props.match.params.applicationId,
      role: window.store.getState().api.user.info.operationAuths.split(','),
      refuseModalShow: false,
      historyModalShow: false,
      tipVisible: false,
      reportInfo: {},
      showHistoryListModal: false,
      reasonMessage: '',
      aiReport: [],
      isLoading: false,
      clickedKnowledgeInfo: [],
      operateName: '',
      oneNameList: [],
      dangerChecked: false,
      oldFinding: '',
      oldSug: '',
      productionId: '101',
      // evaluateVisible: false,
      nboxReviewResultCode: '',
      minTime: 0,
      reportType: '1',
      commentValue: undefined,
    };
  }

  componentDidMount() {
    this.getReport();
    this.getOneNameDiagList();
    aiReportLocalStorage(this.updateReportContent);

    if (this.state.state === '12')
      this.diagnosisRefuseReportReason(this.state.applicationId);
  }

  submitBtnState = () => {
    const { reportInfo } = this.state;
    const reportTime = window.store.getState().api.current.reportTime;
    const len = reportInfo.parts.length;
    const state = reportInfo.state;
    let [time1, time2, minTime] = [0, 0, 0];
    if (state === 11) {
      //报告中
      reportTime.forEach(item => {
        if (item.code === 'report_time_min') time1 = parseInt(item.name);
        else if (item.code === 'report_time_q') time2 = parseInt(item.name);
      });
    } else if (state === 21) {
      //审核中（一审）
      reportTime.forEach(item => {
        if (item.code === 'review_time_min') time1 = parseInt(item.name);
        else if (item.code === 'review_time_q') time2 = parseInt(item.name);
      });
    }
    minTime = time1 + time2 * (len - 1);
    const deadline = Date.now() + minTime * 1000;
    this.setState({ deadline, minTime });
  };
  // sdkParent = () => {
  //   const _this = this;
  //   var sdk = {
  //     postAIReportInfo: function(info) {
  //       const { reportInfo } = _this.state;
  //       if (info.type === 'finding')
  //         reportInfo.radiographyDescription = info.value;
  //       else if (info.type === 'impression')
  //         reportInfo.diagnosisDescription = info.value;
  //       _this.setState({ reportInfo });
  //     },
  //   };

  //   //监听接收
  //   window.addEventListener('message', function(e) {
  //     var data = e.data;
  //     var info = e.data.info;
  //     switch (data.action) {
  //       case 'postAIReportInfo':
  //         sdk.postAIReportInfo(info);
  //         break;
  //       default:
  //         return;
  //     }
  //   });
  // };
  //获取同名人历史信息
  getOneNameDiagList = () => {
    const { diagId } = this.state;
    apis.oneNameDiagList(diagId).then(res => {
      if (res.code === '0') {
        this.setState({
          oneNameList: res.data,
          selectedNameData: res.data[0] || {},
        });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  getAiReport = data => {
    const subVos = data.subVos || [];
    let aiReport = [];
    for (let i = 0; i < subVos.length; i++) {
      if (subVos[i].selectFlag) {
        apis.selectAiReport(subVos[i].dicomDrId).then(res => {
          if (res.code === '0') {
            aiReport.push({ dicomId: subVos[i].dicomDrId, data: res.data });
            this.setState({ aiReport });
          } else if (res.code === '1009') {
            message.warning('请先登录');
            this.props.history.push('/login');
          }
        });
      }
    }
  };

  updateReportContent = () => {
    const { aiReport, reportInfo } = this.state;
    const report = JSON.parse(window.localStorage.getItem('aiReport'));
    const { diagIds, findingIds } = report;

    let [diagContent, findingContent] = [[], []];
    aiReport.forEach(r => {
      r.data.forEach(d => {
        if (diagIds.indexOf(d.id) >= 0) diagContent.push(d.description);
        const findings = d.findings || [];
        findings.forEach(f => {
          if (findingIds.indexOf(f.id) >= 0)
            findingContent.push(f.position + '，' + f.texture);
        });
      });
    });
    diagContent = diagContent.join(`\n`) || '心肺膈无异常';
    findingContent = findingContent.join(`\n`) || '无';

    let radiography = reportInfo.radiographyDescription;
    radiography = radiography ? radiography + `\n` : '';

    let diagnosis = reportInfo.diagnosisDescription;
    diagnosis = diagnosis ? diagnosis + `\n` : '';

    reportInfo.radiographyDescription = radiography + findingContent;
    reportInfo.diagnosisDescription = diagnosis + diagContent;
    this.setState({ reportInfo });
  };

  setCountTime = () => {
    const { reportInfo } = this.state;
    const { state, startReportTime, startVerifyTime } = reportInfo;
    let time = '';
    if (state === 11) time = startReportTime;
    else if (state === 21) time = startVerifyTime;
    else if (state === 26) time = startVerifyTime;
    const formatdate = setCountTime(time);
    this.countDownFun(formatdate);
  };

  countDownFun = time => {
    let end_time = new Date(time).getTime(),
      sys_second = end_time - new Date().getTime();
    const { reportInfo } = this.state;
    const _this = this;
    this.timer = setInterval(() => {
      if (!document.getElementById('reportDetail')) {
        clearInterval(this.timer);
      } else {
        //防止倒计时出现负数
        if (sys_second > 1000) {
          sys_second -= 1000;
          let minute = Math.floor((sys_second / 1000 / 60) % 60);
          let second = Math.floor((sys_second / 1000) % 60);
          this.setState({
            lastTime: minute + '分' + second + '秒',
            endTime: end_time,
          });
        } else {
          const { state, reportId, diagId } = reportInfo;
          clearInterval(this.timer);
          this.setState({ lastTime: '0分0秒' });
          let des = '';
          if (state === 11) des = '您花的时间太长了，请问还需要继续填写吗？';
          else if (state === 21)
            des = '您花的时间太长了，请问还需要继续审核吗？';
          else if (state === 26)
            des = '您花的时间太长了，请问还需要继续审核吗？';
          confirm({
            title: '提示',
            content: des,
            okText: '继续填写',
            okType: 'danger',
            cancelText: '放弃填写',
            onOk() {
              let url;
              if (state === 11) url = apis.continueReport(diagId);
              else if (state === 21) url = apis.continueVerify(reportId);
              else if (state === 26) url = apis.continueVerify(reportId);

              _this.setState({ isLoading: true });
              url.then(res => {
                _this.setState({ isLoading: false });
                if (res.code === '0') {
                  message.success('操作成功');
                  if (state === 11) _this.getWriteReport(diagId);
                  else _this.getVerifyReport(diagId);
                } else {
                  message.error(res.message);
                  if (res.code === '1009') _this.props.history.push('/login');
                }
              });
            },
            onCancel() {
              const { state } = reportInfo;
              if ([11, 21, 26].includes(state))
                _this.setState({ isLoading: true });

              if (state === 11) _this.quitReport();
              else if (state === 21) _this.quitVerify();
              else if (state === 26) _this.quitVerify();
            },
          });
        }
      }
    }, 1000);
  };

  back = () => {
    const { reportInfo, productionId } = this.state;
    const { state } = reportInfo;
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0004', 'ns-005'];
    } else if ([21, 26].includes(state)) {
      [pageId, moduleId, elementId] = ['10020', 'mk0004', 'ns-005'];
    } else {
      [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-006'];
    }
    eventListener({ productionId, pageId, moduleId, elementId });

    const detail = qs.parse(window.location.search).detail;
    const stateArray = [40, 26, 21, 11];
    const text = `报告状态最多暂存60分钟，若60分钟内未提交报告，将会清空数据，由其他医生`;
    let des = '';
    if (state === 11) des = text + '填写报告';
    else if (state === 21) des = text + '审核报告';
    else if (state === 26) des = text + '审核报告';
    if (
      [11, 26].includes(state) ||
      (state === 21 && !(detail === 'true' && !stateArray.includes(state)))
    ) {
      const _this = this;
      confirm({
        title: '提示',
        content: des,
        okText: '知道了',
        okType: 'danger',
        cancelText: '关闭',
        onOk() {
          clearInterval(_this.timer);
          _this.props.history.go(-1);
        },
      });
    } else this.props.history.go(-1);
  };

  getReport = () => {
    const { diagId, state, applicationId, role } = this.state;
    const stateArray = ['22', '30', '12', '40', '42', '46'];
    const stateArray1 = ['20', '201'];
    const isInArray1 = stateArray1.includes(state);
    const isInArray = stateArray.includes(state);

    const detail = qs.parse(window.location.search).detail;
    const stateArray3 = ['40', '26', '21', '11'];
    if (detail === 'true' && !stateArray3.includes(state)) {
      this.getReportInfo(applicationId);
    } else if (['10', '11'].includes(state)) {
      this.getWriteReport(diagId, 'init');
    } else if ((isInArray1 && role.includes('T')) || state === '21') {
      this.getVerifyReport(diagId, 'init');
    } else if (role.includes('T2') && state === '26') {
      this.getVerifyReport(diagId, 'init');
    } else if ((isInArray1 && role.includes('M')) || isInArray) {
      this.getReportInfo(applicationId);
    } else if (role.includes('T') && state === '25') {
      this.getReportInfo(applicationId);
    }
  };

  //报告详情
  getReportInfo = async applicationId => {
    const data = await reportInfo(applicationId);
    const { state, critical } = data;
    this.setState({
      reportInfo: data,
      // evaluateVisible: false,
      dangerChecked: critical,
    });
    if ([26, 21, 11].includes(state)) this.setCountTime();
  };

  //填写报告
  getWriteReport = (diagId, type) => {
    apis.writeReport(diagId).then(res => {
      if (res.code === '0') {
        const info = res.data;
        this.setState(
          { reportInfo: info, dangerChecked: info.critical },
          () => {
            if (type === 'init') {
              this.toViewer();
              this.getAiReport(info);
            }
          }
        );
        this.submitBtnState();
        this.setCountTime();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  //审核报告
  getVerifyReport = (diagId, type) => {
    apis.verifyReport(diagId).then(res => {
      if (res.code === '0') {
        const info = res.data;
        this.setState({
          reportInfo: info,
          dangerChecked: info.critical,
          oldFinding: info.radiographyDescription,
          oldSug: info.diagnosisDescription,
        });
        this.submitBtnState();
        this.setCountTime();
        if (type === 'init') this.toViewer();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  toViewer = (type, record) => {
    let { reportInfo } = this.state;

    let url = `/viewer/study/${reportInfo.studyUid}?applicationId=${reportInfo.applicationId}&from=report`;
    if (type === 'history') url += '&ishistory=true';
    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;

    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'report', str);
  };
  /**
   *
   * @param {1:提交报告;0:暂存报告} flag
   * @param {危急值} dangerValue
   */
  saveReport = (flag, dangerValue) => {
    //flag 1:提交报告 0:暂存报告
    const _this = this;

    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    this.props.changeMenuTaskData(time);
    if (flag === 1) {
      this.apiSaveReport(flag, dangerValue);
    } else {
      confirm({
        title: '提示',
        content:
          '报告最多暂存60分钟，若60分钟内未提交报告，将会清空数据，由其他医生填写报告',
        okText: '知道了',
        okType: 'danger',
        cancelText: '关闭',
        onOk() {
          _this.apiSaveReport(flag, dangerValue);
        },
      });
    }
  };
  //暂存审核
  tsReview = (flag, dangerValue) => {
    const _this = this;
    confirm({
      title: '提示',
      content:
        '审核报告最多暂存60分钟，若60分钟内未提交审核，将会清空数据，由其他医生审核',
      okText: '知道了',
      okType: 'danger',
      cancelText: '关闭',
      onOk() {
        _this.apiTsReview(flag, dangerValue);
      },
    });
  };
  apiTsReview = (flag, dangerValue) => {
    this.setState({ isLoading: true });
    const { diagId, reportInfo, clickedKnowledgeInfo } = this.state;
    const { dangerChecked } = this.state;
    const { nboxReviewResultCode, nboxReviewDetails } = this.state;
    const { radiographyDescription, diagnosisDescription } = reportInfo;

    const post = {
      diagId, //必填
      radiographyDescription, //影像所见描述
      diagnosisDescription, //诊断意见
      saveFlag: flag, //必填 0暂存， 1保存nboxReviewDetails
      kls: clickedKnowledgeInfo,
      nboxReviewResultCode,
      nboxReviewDetails,
      aiReportId: reportInfo.aiReportId,
    };
    if (dangerValue) post.critical = dangerValue;
    else post.critical = dangerChecked;
    apis.tempSaveVerify(post).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('提交成功');
        if (flag === 1) this.props.history.go(-1);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  setClickedKnowledgeInfo = record => {
    this.setState({ clickedKnowledgeInfo: record });
  };
  /**
   *
   * @param {危急值} dangerValue
   * @param {疑难转诊} needReview2
   * @returns
   * diagnosisGrade诊断报告评分
   * aiFinding AI影像所见
   * radiographyDescription 医生影像所见
   * aiImpression AI诊断建议
   * diagnosisDescription 医生诊断建议
   * kls 点击的知识库列表
   */
  saveReview = (dangerValue, needReview2) => {
    const { reportInfo, dangerChecked, reportType } = this.state;
    const { diagnosisGrade, diagId } = reportInfo;
    const { radiographyDescription, diagnosisDescription } = reportInfo;
    const { aiFinding, aiImpression } = reportInfo;

    let { nboxReviewResultCode, nboxReviewDetails } = this.state;

    let post = {
      diagId,
      diagnosisGrade,
      radiographyDescription:
        reportType === '2' ? aiFinding : radiographyDescription,
      diagnosisDescription:
        reportType === '2' ? aiImpression : diagnosisDescription,
    };

    //如果提交的是AI诊断报告，需要传AI报告的ID
    if (reportType === '2') post.aiReportId = reportInfo.aiReportId;

    post.kls = this.state.clickedKnowledgeInfo;
    post = { ...post, nboxReviewResultCode, nboxReviewDetails };
    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    this.props.changeMenuTaskData(time);

    post.critical = dangerValue ? dangerValue : dangerChecked;
    if (needReview2) post.needReview2 = needReview2;
    apis.saveVerify(post).then(res => {
      if (res.code === '0') {
        message.success('保存成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  apiSaveReport = (flag, dangerValue) => {
    this.setState({ isLoading: true });
    const { diagId, reportInfo, clickedKnowledgeInfo } = this.state;
    const { dangerChecked } = this.state;
    const { nboxReviewResultCode, nboxReviewDetails } = this.state;
    const { radiographyDescription, diagnosisDescription } = reportInfo;

    const post = {
      diagId, //必填
      radiographyDescription, //影像所见描述
      diagnosisDescription, //诊断意见
      saveFlag: flag, //必填 0暂存， 1保存nboxReviewDetails
      kls: clickedKnowledgeInfo,
      nboxReviewResultCode,
      nboxReviewDetails,
      aiReportId: reportInfo.aiReportId,
    };
    if (dangerValue) post.critical = dangerValue;
    else post.critical = dangerChecked;
    apis.saveReport(post).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('提交成功');
        if (flag === 1) this.props.history.go(-1);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  //放弃填写
  quitReport = () => {
    const { diagId } = this.state.reportInfo;
    apis.quitReport(diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('操作成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //放弃审核
  quitVerify = () => {
    const { diagId } = this.state.reportInfo;
    apis.quitVerify(diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('操作成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //退回重写
  refuseReView = () => {
    const { diagId } = this.state.reportInfo;
    apis.refuseReView(diagId).then(res => {
      if (res.code === '0') {
        message.success('操作成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //“拒绝报告”弹出框
  refuseVisible = state => {
    this.setState({ refuseModalShow: state });
  };
  //操作记录弹出框
  historyModalVisible = state => {
    this.setState({ historyModalShow: state });
  };
  //提示信息弹出框
  tipAlertVisible = (state, name) => {
    this.setState({ tipVisible: state, operateName: name });
  };
  //历史记录弹出框
  historyListVisible = state => {
    this.setState({ showHistoryListModal: state });
  };

  //影像所见输入框内容
  handleChangeGrade = ({ target: { value } }) => {
    let { reportInfo, reportType } = this.state;
    if (reportType === '2') {
      reportInfo.aiFinding = value;
    } else {
      reportInfo.radiographyDescription = value;
    }

    this.setState({ reportInfo });
  };

  //诊断建议输入框内容
  handleChangeDiagnosisGrade = ({ target: { value } }) => {
    let { reportInfo, reportType } = this.state;
    if (reportType === '2') {
      reportInfo.aiImpression = value;
    } else {
      reportInfo.diagnosisDescription = value;
    }

    this.setState({ reportInfo });
  };

  //获取拒绝原因
  diagnosisRefuseReportReason = id => {
    apis.diagnosisRefuseReportReason(id).then(res => {
      if (res.code === '0') {
        this.setState({ reasonMessage: res.data });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  clearTextarea = type => {
    const { reportInfo, productionId, reportType } = this.state;
    const { state } = reportInfo;
    let types;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (type === 'radiography') {
      [moduleId, elementId] = ['mk0002', 'ns-002'];
      if (state === 11) pageId = '10019';
      else if ([21, 26].includes(state)) pageId = '10020';
      eventListener({ ...eventData, pageId, moduleId, elementId });

      if (reportType === '2') reportInfo.aiFinding = '';
      else reportInfo.radiographyDescription = '';

      types = '1';
    } else if (type === 'diagnosis') {
      [moduleId, elementId] = ['mk0002', 'ns-005'];
      if (state === 11) pageId = '10019';
      else if ([21, 26].includes(state)) pageId = '10020';
      eventListener({ ...eventData, pageId, moduleId, elementId });

      if (reportType === '2') reportInfo.aiImpression = '';
      else reportInfo.diagnosisDescription = '';

      types = '2';
    }
    if (typeof reportInfo.aiReportId === 'number' && reportType !== '2') {
      const post = { id: reportInfo.aiReportId, types };
      if (reportInfo.state === 11) post.report = true;
      apis.rmAiTxt(post).then(res => {});
    }
    this.setState({ reportInfo });
  };

  setReportInfo = record => this.setState({ reportInfo: record });

  dangerOnchange = e => this.setState({ dangerChecked: e.target.checked });

  tabOnChange = activeKey => {
    const { productionId } = this.state;

    if (activeKey === '1') {
      const [pageId, moduleId] = ['10023', 'mk0002'];
      const eventData = { productionId, pageId, moduleId };
      eventListener({ ...eventData, elementId: 'ns-012' });
    } else if (activeKey === '2') {
      const [pageId, moduleId, elementId] = ['10019', 'mk0003', 'ns-010'];
      eventListener({ productionId, pageId, moduleId, elementId });
    }
  };

  // evaluateTip = state => this.setState({ evaluateTipVisible: state });
  reportTypeChange = value => {
    this.setState({ reportType: value });
  };
  diagnosisGradeChange = e => {
    const { reportInfo } = this.state;
    reportInfo.diagnosisGrade = e.target.value;
    this.setState({ reportInfo });
  };
  commentChange = e => {
    this.setState({ commentValue: e.target.value });
    if (e.target.value === '0')
      this.setState({ nboxReviewResultCode: e.target.value });
  };
  commentReasonChange = value => {
    let string = value.join(',');
    string = string || '';
    this.setState({ nboxReviewResultCode: string });
  };
  autoInputChange = ({ target: { value } }) => {
    this.setState({ nboxReviewDetails: value });
  };
  reportComment = () => {
    const content = (
      <div className="report-tip-cnt">
        <p>
          <i>严重差错</i>
          --外伤性病变、重大疾病（肿瘤、急危诊）误、漏诊，包括左右定位或部位严重错位；
        </p>
        <p>
          <i>一般性差错</i>
          --主要基本或病变诊断没有误、漏诊，但是次要病变或周围性病变误漏诊，不会造成严重事故或纠纷的差错；
        </p>
        <p>
          <i>用语不当/逻辑差错</i>
          --不遵守影像报告一般规范，报告前后不符合逻辑，报告描述或建议影像影响报告使用人员误解或难理解等等。
        </p>
      </div>
    );
    const { reportInfo, role } = this.state;
    const { state } = reportInfo;
    if (state >= 21 && isIncluded(['T', 'M', 'T2'], role) && state !== 26) {
      return (
        <div className="comment">
          <div className="title">
            报告评价
            <Popover content={content} placement="topLeft">
              <Button type="link" icon="question-circle"></Button>
            </Popover>
          </div>
          <div className="report-feedback-cnt">
            <Radio.Group
              onChange={this.diagnosisGradeChange}
              value={this.state.reportInfo.diagnosisGrade}
              disabled={state > 21}
            >
              <Radio value={0}>严重差错</Radio>
              <Radio value={1}>一般性差错</Radio>
              <Radio value={3}>用语不当/逻辑欠妥</Radio>
              <Radio value={5}>报告正确完整</Radio>
            </Radio.Group>
          </div>
        </div>
      );
    }
  };
  commentContent = () => {
    const { reportInfo, role, commentValue } = this.state;
    const { state, aiReportUrl } = reportInfo;
    if (
      [11, 21, 26].includes(state) &&
      isIncluded(['T', 'M', 'T2'], role) &&
      aiReportUrl
    ) {
      const comment1 = [
        { label: '标画准确、全面', value: '1' },
        { label: '主要病灶标画准确', value: '2' },
        { label: '诊断意见准确', value: '3' },
      ];
      const comment2 = [
        { label: '标画错误', value: '-1' },
        { label: '主要病灶未标画', value: '-2' },
        { label: '描述不准确', value: '-3' },
        { label: '描述不全面', value: '-4' },
        { label: '其它原因', value: '-5' },
        { label: '部分不采纳', value: '-7' },
        { label: '影像阴性', value: '-6' },
      ];

      return (
        <div className="comment">
          <div className="title">AI结果评价</div>
          <div className="report-feedback-cnt">
            <Radio.Group onChange={this.commentChange} value={commentValue}>
              <Radio value={true}>采纳</Radio>
              <Radio value={false}>不采纳</Radio>
              <Radio value={'0'}>稍后评价</Radio>
            </Radio.Group>
          </div>
          {[true, false].includes(commentValue) && (
            <>
              <div className="title">结果评价理由</div>
              <div className="report-feedback-cnt">
                <Checkbox.Group
                  options={commentValue ? comment1 : comment2}
                  onChange={this.commentReasonChange}
                />
              </div>
            </>
          )}

          {commentValue === false && (
            <TextArea
              className="auto-input"
              placeholder="请输入详情原因"
              onChange={this.autoInputChange}
            />
          )}
        </div>
      );
    }
  };
  render() {
    // const { evaluateVisible } = this.state;
    const { reportInfo, role, isLoading, reportType } = this.state;
    const { oneNameList, deadline, minTime, listWidth } = this.state;
    const { productionId } = this.state;
    const { state, aiReportId } = reportInfo;
    const leftHeight = parseInt((document.body.clientHeight - 170).toString());

    const disabledArray = [1, 10, 12, 20, 25, 22, 30, 201, 42, 46];
    let inputDisabled = disabledArray.includes(state);

    const detail = qs.parse(window.location.search).detail;
    const stateArray = [40, 26, 21, 11];
    if (
      detail === 'true' &&
      (!stateArray.includes(state) ||
        (state === 21 && role.includes('T2') && !role.includes('T')))
    )
      inputDisabled = true;

    const isSmall = document.body.clientWidth < 1200;

    return (
      <div className="form-bg" id="reportDetail">
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['诊断报告'])}</Breadcrumb>
              <div className="back" onClick={this.back}>
                &lt;返回
              </div>
            </div>
            <div className="box detail-form" style={{ width: listWidth }}>
              {/* 如果不是可修改的状态，隐藏左侧知识库 */}
              {!inputDisabled && (
                <Tabs defaultActiveKey="1" onChange={this.tabOnChange}>
                  <TabPane tab="知识库" key="1">
                    <Knowledge
                      leftHeight={leftHeight}
                      setReportInfo={this.setReportInfo}
                      reportInfo={reportInfo}
                      setClickedKnowledgeInfo={this.setClickedKnowledgeInfo}
                      history={this.props.history}
                    />
                  </TabPane>
                  {oneNameList.length > 0 && (
                    <TabPane tab="历史报告" key="2">
                      <OneNameHistory
                        leftHeight={leftHeight}
                        oneNameList={oneNameList}
                        toViewer={this.toViewer}
                      />
                    </TabPane>
                  )}
                </Tabs>
              )}
              <div className="report-center">
                <ApplyInfo
                  reportInfo={reportInfo}
                  isSmall={isSmall}
                  role={role}
                  toViewer={this.toViewer}
                  historyListVisible={this.historyListVisible}
                  dangerOnchange={this.dangerOnchange}
                  dangerChecked={this.state.dangerChecked}
                />
                {state === 21 && aiReportId && (
                  <Tabs type="card" onChange={this.reportTypeChange}>
                    <TabPane tab="医生诊断报告" key="1"></TabPane>
                    <TabPane tab="AI辅助诊断报告" key="2"></TabPane>
                  </Tabs>
                )}

                <div className="report-cnt">
                  <div className="report-title">
                    <Icon type="file-text" theme="filled" />
                    影像所见
                    {!inputDisabled && (
                      <Button
                        className="btn-clear btn-right"
                        type="default"
                        size="small"
                        onClick={() => this.clearTextarea('radiography')}
                      >
                        <ClearIcon />
                      </Button>
                    )}
                  </div>
                  <TextArea
                    rows={8}
                    value={
                      reportType === '2'
                        ? reportInfo.aiFinding || ''
                        : reportInfo.radiographyDescription || ''
                    }
                    onChange={this.handleChangeGrade}
                    style={{ fontSize: isSmall ? '12px' : '16px' }}
                    disabled={inputDisabled}
                    onBlur={() => {
                      let [moduleId, elementId] = ['mk0002', 'ns-001'];
                      let pageId;
                      if (state === 11) pageId = '10019';
                      else if ([21, 26].includes(state)) pageId = '10020';
                      eventListener({
                        productionId,
                        pageId,
                        moduleId,
                        elementId,
                      });
                    }}
                  />
                  <div className="report-title">
                    <Icon type="file-text" theme="filled" />
                    诊断建议
                    {!inputDisabled && (
                      <Button
                        className="btn-clear btn-right"
                        type="default"
                        size="small"
                        onClick={() => this.clearTextarea('diagnosis')}
                      >
                        <ClearIcon />
                      </Button>
                    )}
                  </div>
                  <TextArea
                    rows={8}
                    value={
                      reportType === '2'
                        ? reportInfo.aiImpression || ''
                        : reportInfo.diagnosisDescription || ''
                    }
                    onChange={this.handleChangeDiagnosisGrade}
                    style={{ fontSize: isSmall ? '12px' : '16px' }}
                    disabled={inputDisabled}
                    onBlur={() => {
                      let [moduleId, elementId] = ['mk0002', 'ns-004'];
                      let pageId;
                      if (state === 11) pageId = '10019';
                      else if ([21, 26].includes(state)) pageId = '10020';
                      eventListener({
                        productionId,
                        pageId,
                        moduleId,
                        elementId,
                      });
                    }}
                  />
                  <Score
                    report={reportInfo}
                    update={this.setReportInfo}
                    isSmall={isSmall}
                    role={role}
                  />
                  {state === 12 && (
                    <div className="report-doctor">
                      <p>拒绝原因</p>
                      {this.state.reasonMessage}
                    </div>
                  )}
                  {this.reportComment()}
                  {this.commentContent()}
                  <ReportButtons
                    reportInfo={reportInfo}
                    saveReport={this.saveReport}
                    role={role}
                    history={this.props.history}
                    tipAlertVisible={this.tipAlertVisible}
                    refuseVisible={this.refuseVisible}
                    historyModalVisible={this.historyModalVisible}
                    changeMenuTaskData={this.props.changeMenuTaskData}
                    getWriteReport={this.getWriteReport}
                    getVerifyReport={this.getVerifyReport}
                    update={this.setReportInfo}
                    getReportInfo={this.getReportInfo}
                    lastTime={this.state.lastTime}
                    endTime={this.state.endTime}
                    dangerChecked={this.state.dangerChecked}
                    oldFinding={this.state.oldFinding}
                    oldSug={this.state.oldSug}
                    deadline={deadline}
                    minTime={minTime}
                    reportType={this.state.reportType}
                    nboxReviewResultCode={this.state.nboxReviewResultCode}
                    tsReview={this.tsReview}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 选择拒绝报告原因 */}
        <Refuse
          visible={this.state.refuseModalShow}
          onCancel={this.refuseVisible}
          reportInfo={reportInfo}
          changeMenuTaskData={this.props.changeMenuTaskData}
          history={this.props.history}
        />
        {/* 提示 */}
        <AlertTips
          visible={this.state.tipVisible}
          operateName={this.state.operateName}
          saveReport={this.saveReport}
          saveReview={this.saveReview}
          quitReport={this.quitReport}
          quitVerify={this.quitVerify}
          refuseReView={this.refuseReView}
          onCancel={this.tipAlertVisible}
        />
        {/* 操作记录 */}
        <History
          visible={this.state.historyModalShow}
          onCancel={this.historyModalVisible}
          reportInfo={reportInfo}
        />
        {/* //历史报告 */}
        <HistoryList
          onCancel={this.historyListVisible}
          visible={this.state.showHistoryListModal}
          reportInfo={reportInfo}
        />
      </div>
    );
  }
}

export default withRouter(Report);
